import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getHighlightingText } from '../../../../../../../utils/helper';

const ServicesTableRow = ({ index, style, service, query, query_type }) => {
  const isDeleted = !!service?.is_deleted;
  return (
    <div key={index} style={style} className="reports-services-table__body">
      <div className={classNames('reports-services-table__row', {
        'reports-services-table__row-disabled': !service.status,
      })}
      >
        <div className="reports-services-table__row-td reports-services-table__row-id">
          <span
            dangerouslySetInnerHTML={getHighlightingText(service.id, query, Number(query_type) === 2)}
          />
        </div>
        <div className="reports-services-table__row-td reports-services-table__row-name">
          {isDeleted ? 'DELETED'
            : (
              <span
                dangerouslySetInnerHTML={getHighlightingText(service.name, query, Number(query_type) === 1)}
              />
            )}
        </div>
        <div className="reports-services-table__row-td reports-services-table__row-cost">{service.count_orders}</div>
        <div className="reports-services-table__row-td reports-services-table__row-cost">{service.charge}</div>
        <div className="reports-services-table__row-td reports-services-table__row-cost">{service.cost}</div>
        <div className="reports-services-table__row-td reports-services-table__row-cost">{service.profit}</div>
        <div className="reports-services-table__row-td reports-services-table__row-cost">{service.refunded}</div>
      </div>
    </div>
  )
}

ServicesTableRow.propTypes = {
  index: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  service: PropTypes.object.isRequired,
  query: PropTypes.string,
  query_type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ServicesTableRow;
